module.exports = __webpack_public_path__ + "img/personal-info-gray.7f5d1682.svg";